import React from 'react';
import { connect } from 'react-redux';
import { Button, Row, Col, Modal } from 'react-bootstrap';
import { saveChangelogVersion } from '@/store/allaround.store';
import help from '@/../style/help.png';

class Changelog extends React.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.state = {
      showModal: false,
    };
  }
  componentWillMount() {
    if (this.props.currentVersion &&
      (this.props.changelogVersion != this.props.currentVersion)) {
      this.setState({ showModal: true });
    }
  }
  componentWillReceiveProps(props) {
    if (props.currentVersion &&
      (props.changelogVersion != props.currentVersion)) {
      this.setState({ showModal: true });
    }
  }
  openModal() {
    this.setState({ showModal: true });
  }
  closeModal() {
    this.setState({ showModal: false });
    if (!this.props.changelogVersion ||
      (this.props.changelogVersion != this.props.currentVersion)) {
      this.props.saveChangelogVersion(this.props.currentVersion);
    }
  }

  render() {
    return (
      <div title="What's new" onClick={this.openModal} style={{ padding: '12px 15px' }}>
        <img src={help} alt={'Changelog'} className={'changelog-icon'} />
        <Modal
          show={this.state.showModal}
          onHide={() => this.closeModal()}
          bsSize="large"
        >
          <Modal.Header style={{ padding: '5px 20px', fontSize: '15px' }}>
            New features and additions
          </Modal.Header>
          <Modal.Body
            style={{ paddingTop: '0px', paddingBottom: '0px', height: '70vh', overflowY: 'auto' }}
          >
            <Row>
              <Col xs={12}>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 11.1
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Transport profit/loss in Custom reports
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 11.0
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Redesign.
                  </Col>
                  <Col xs={12}>
                    2. Quantity validation of multi-nodal purchases .
                  </Col>
                  <Col xs={12}>
                    3. Customizable system currencies.
                  </Col>
                  <Col xs={12}>
                    4. Position map - unpriced totals.
                  </Col>
                  <Col xs={12}>
                    5. Payments screen - today payments highlight.
                  </Col>
                  <Col xs={12}>
                    6. New validation of linked transport's freight.
                  </Col>
                  <Col xs={12}>
                    7. Shrinkage quantity.
                  </Col>
                  <Col xs={12}>
                    8. Changed of transhipment expense calculation logic.
                  </Col>
                  <Col xs={12}>
                    9. Counterparty info in payments notifications.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 10.1
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Multinodal purchase tab and corresponding report.
                  </Col>
                  <Col xs={12}>
                    2. Ability to set unlinked quantity to 0.
                  </Col>
                  <Col xs={12}>
                    3. LS/PT switch for transports' freight.
                  </Col>
                  <Col xs={12}>
                    4. Overdue payments email notifications.
                  </Col>
                  <Col xs={12}>
                    5. Custom totals in Supply/Demand report.
                  </Col>
                  <Col xs={12}>
                    6. Earnings Statements report.
                  </Col>
                  <Col xs={12}>
                    7. Common payments are now shown also at incoming and outgoing tab.
                  </Col>
                  <Col xs={12}>
                    8. Cargo insuranse checkbox.
                  </Col>
                  <Col xs={12}>
                    9. Custom reports - quantity is now shown once for each deal.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 10.0
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <h4 style={{ color: 'red', display: 'inline' }}>1. Concurrent work. </h4>
                    Deals can be opened in edit mode only by one user at a time
                    , while everyone else will have read-only access.
                    Still, there is an option to take over the edit mode
                    , locking out previous lock owner
                    (<b>All unsaved changes will be lost during this action!</b>)
                  </Col>
                  <Col xs={12}>
                    2. Analytics report.
                  </Col>
                  <Col xs={12}>
                    3. Supply/demand table.
                  </Col>
                  <Col xs={12}>
                    4. User performance report.
                  </Col>
                  <Col xs={12}>
                    5. Counterparty outstanding - summing up function.
                  </Col>
                  <Col xs={12}>
                    6. Security - region limited mode in custom report.
                  </Col>
                  <Col xs={12}>
                    7. Abnormal transport freight warning.
                  </Col>
                  <Col xs={12}>
                    8. Custom reports - payments and profits are now shown only once for each deal.
                  </Col>
                  <Col xs={12}>
                    9. Changes to profitability calculation.
                  </Col>
                  <Col xs={12}>
                    10. Payments tab performance tuning.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 9.3
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Performance report.
                  </Col>
                  <Col xs={12}>
                    2. Transport-less linking with BL.
                  </Col>
                  <Col xs={12}>
                    3. Ability to link P/S to existing S/P-T link.
                  </Col>
                  <Col xs={12}>
                    4. Changes to interest calculation.
                  </Col>
                  <Col xs={12}>
                    5. New table in purchases - "values for interest calculation".
                  </Col>
                  <Col xs={12}>
                    6. Total info in position map and book.
                  </Col>
                  <Col xs={12}>
                    7. Changes to position book M2M calculation.
                  </Col>
                  <Col xs={12}>
                    8. Nightly copying of sales' responsibles to linked transports.
                  </Col>
                  <Col xs={12}>
                    9. Currency exchange rates now have up to 4 decimal points.
                  </Col>
                  <Col xs={12}>
                    10. Search in payments page.
                  </Col>
                  <Col xs={12}>
                    11. Counterparty legal name in payments.
                  </Col>
                  <Col xs={12}>
                    12. Links restyle.
                  </Col>
                  <Col xs={12}>
                    13. Security - each user can be logged in only from one place at the same time.
                  </Col>
                  <Col xs={12}>
                    14. Security - position book permissions for each of the product.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 9.2
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. M2M prices import.
                  </Col>
                  <Col xs={12}>
                    2. Common payments with respective flag can now be used
                    for profit calculation report.
                  </Col>
                  <Col xs={12}>
                    3. Deals cut off date system-wide setting.
                  </Col>
                  <Col xs={12}>
                    4. New columns in custom report.
                  </Col>
                  <Col xs={12}>
                    5. XLS export of counterparty outstandings report.
                  </Col>
                  <Col xs={12}>
                    6. Changes to P/L tab.
                  </Col>
                  <Col xs={12}>
                    7. New product groups for position book.
                  </Col>
                  <Col xs={12}>
                    8. Average days of carrying report.
                  </Col>
                  <Col xs={12}>
                    9. Date sorting in XLS custom report.
                  </Col>
                  <Col xs={12}>
                    10. Warning when entering huge quantity amounts into a deal.
                  </Col>
                  <Col xs={12}>
                    11. Deal creation email notification for finances role.
                  </Col>
                  <Col xs={12}>
                    12. Changes to logics of email notifications about transports with empty fields.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 9.1
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Consolidated list of purchases and sales.
                  </Col>
                  <Col xs={12}>
                    2. Total BL info in transports.
                  </Col>
                  <Col xs={12}>
                    3. Legal name column in payments.
                  </Col>
                  <Col xs={12}>
                    4. Actuals costs columns in the custom report.
                  </Col>
                  <Col xs={12}>
                    5. Alert when entering large quantity amounts.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 9.0
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Profit/Loss tab in deals with profit calculation details.
                  </Col>
                  <Col xs={12}>
                    2. Trades concluded report is now YTD.
                  </Col>
                  <Col xs={12}>
                    3. Contract payment has DR/CR switch unlocked.
                  </Col>
                  <Col xs={12}>
                    4. New role - Guest.
                  </Col>
                  <Col xs={12}>
                    5. Port sorting in position book now sorts by country first.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 8.1
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Export of shipping documents.
                  </Col>
                  <Col xs={12}>
                    2. System audit.
                  </Col>
                  <Col xs={12}>
                    3. Changes to notification of Missing BL data.
                  </Col>
                  <Col xs={12}>
                    4. Payments with less than 1$ outstanding are now considered closed.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 8.0
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Contract payment entry mechanism.
                  </Col>
                  <Col xs={12}>
                    2. Quarter reports.
                  </Col>
                  <Col xs={12}>
                    3. New admin notifications.
                  </Col>
                  <Col xs={12}>
                    4. Predefined counterparty outstandings.
                  </Col>
                  <Col xs={12}>
                    5. Bank repayment date in payments.
                  </Col>
                  <Col xs={12}>
                    6. Additional fields in counteparty references.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 7.4
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. New transport type - Truck.
                  </Col>
                  <Col xs={12}>
                    2. FOB Netback displays only on specific conditions.
                  </Col>
                  <Col xs={12}>
                    3. Employee reference removed.
                  </Col>
                  <Col xs={12}>
                    4. New user role - Managment.
                  </Col>
                  <Col xs={12}>
                    5. Changed earliest deal shipment date for
                     notifications from 1 Oct 17 to 1 Dec 17.
                  </Col>
                  <Col xs={12}>
                    6. Reports changes.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 7.3
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Reports released.
                  </Col>
                  <Col xs={12}>
                    2. Deals with 0 unlinked quantity left
                     and no links are no longer considered long/short.
                  </Col>
                  <Col xs={12}>
                    3."Counteparty outstandings" tab collects data from the begining of 2018.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 7.2
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Counteparty outstandings tab.
                     It shows counterparties with sum of their incoming and outgoing outstanding
                      values and its difference.
                  </Col>
                  <Col xs={12}>
                    2. FOB Netback in sales. Users can override estimated value.
                    Actual value is calculateable on the same conditions as the profit.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 7.1
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Save button no longer redirects to the deal
                     list but stays on the deal page.
                  </Col>
                  <Col xs={12}>
                    2. Cancel button in the deal page now navigates to the previous page.
                  </Col>
                  <Col xs={12}>
                    3. Origin selection added to estimated freight expense in sales.
                  </Col>
                  <Col xs={12}>
                    4. "Deal created" notification is now sent upon filling product,
                     price and quantity fields.
                  </Col>
                  <Col xs={12}>
                    5. Payment date is required for contract payments.
                  </Col>
                  <Col xs={12}>
                    6. Due date is required for all payments.
                  </Col>
                  <Col xs={12}>
                    7. Closed payments are now shown in respective tab.
                  </Col>
                  <Col xs={12}>
                    8. Estimated freight expense in sales now has origin selection.
                  </Col>
                  <Col xs={12}>
                    9. Reports functionality is now available for users with managment role.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 7.0
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. System now calculates bank interest based on contract payments.
                    It updates every 30 minutes.
                    Default rate is 4% which was set to all existing deals.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 6.5
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. New field group "Loading/Discharge terms" in purchases and sales.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    2. New field "Transport type" in purchases and sales.
                    The field filters transport while linking.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    3. Changes in notifications.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    4. Users can view linked content of their deals despite permissions.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 6.4
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Payments list UX and its performance tuning.
                    Common counterparties reference removed, common payments uses
                     trade counterparties one.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    2. New notification - "Deal created".
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    3. Mobile versions improvements.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 6.3
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Notification system.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    2. Payments approval system.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 6.2
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. User permissions system.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    2. "Advanced my deals" filter available for some roles.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    3. Trade counterparties reference.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    4. Mobile version for deal creation.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    5. Contract # and Vessel Name in payments are clickable.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    6. Transports with no linked deals have selectable products.
                    The field is required.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    7. Filter for transport linking includes products.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    8. Filter for deal linking compares shipment dates.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    9. "Unlinked" filter in deal list has its logic changed.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    10. Elements recomposition in link windows.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    11. Shipment sorting in deal list is off by default.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    12. Creating deal duplicate no longer copies files and expenses.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 6.1
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Outgoing/Incoming payments tabs.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    2. GB Pound currency.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    3. Deal profitability is uncalculatable if price is set as formula.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 6.0
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Deal content search system.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    2. Payments sorting.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    3. New column for payments - Vessel Name.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    4. Payments filter - achived
                    (payment is considered acrhived when its deal is archived).
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    5. Ability to copy deals.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    6. New product filter - Solubles. Specialty filter is removed.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    7. Commencement of Loading/Discharge and ETC vessel fields
                    have time in addition to date.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 5.5
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Common payments.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    2. Todays payments report.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    3. Transport filtering for linkage dialog.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    4. Deal LS profitability.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    5. Banking cost is counting when creating expense.
                    For contract and freight payments it creates Banking expense.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    6. Estimated freight shows in transport.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    7. Comment field in transport ports
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 5.4
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. BL quantity validation.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    2. Changes in product type filters.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 5.3
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Payments functionality.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 5.2
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Profitability calculation fixes.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    2. Laytime expenses table for transports.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    3. Duplicate deal creation warning.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    4. Dispute deal status.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    5. New delivery term group - 'DAT, DAF, DDP'.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    6. Quantity and BL quantity have 3 decimal length.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    7. Demmurage, dispatch, loading and discharge rates are integer.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    8. New product type filter 'Specialty'.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 5.1
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Archived flag for deals and transports.
                    Items with this mark will no longer be shown in lists and linking windows.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    2. Deals with 0 unlinked quantity are no longer shown in linking window.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    3. Application uses HTTPS protocol.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    4. New transport statuses.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    5. Product filters for transports.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    6. Product quantity is no longer shown and editable if BL quantity is specified.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    7. User can change his password. New password strength rules -
                    10 symbols minimum, atleast 3 of following categories:
                     lowercase, UPPERCASE, numbers, special symbols.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    8. Contract number is required if deal has "Contract singed" status.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    9. AGRI product filter.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 5.0
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Currency and currency rates selection.
                    Deal profitability calculation converts EUR to USD
                    using corresponding rates.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 4.2
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Expenses entry and profitability calculation (actual and estimated).
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 4.1
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    1. Contract number manual entry.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    2. Transport filters.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    3. New pagination and scroll restoration.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    4. B/L quantity is used in "unlinked" calculation.
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ fontWeight: 'bold' }}>
                    Version 4.0
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Row>
                      <Col xs={12}>
                        <h4 style={{ color: 'red', display: 'inline' }}>1. Automatic save. </h4>
                        Purchases, sales and transports will be saved automatically
                        whenever you leave the edit page, unless you close or refresh browser
                        window or click the Cancel button.
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        2. Navigate to deals and transports by clicking on their block.
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        3. Purchase and sale filters.
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        4. New transport type - Railcar.
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        5. On-the-fly reference creation.
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        6. Multiple entry for Responsible field in Deals and Transports.
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        7. Support for fractional Quantity.
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer style={{ padding: '10px' }}>
            <Button
              id="closeWhatsNew"
              onClick={() => this.closeModal()}
              style={{ width: '71', height: '30px', padding: '2px 6px' }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>);
  }
}
Changelog.propTypes = {
  changelogVersion: React.PropTypes.string,
  currentVersion: React.PropTypes.string,
  saveChangelogVersion: React.PropTypes.func,
};
export default connect(
  state => ({
    currentVersion: state.getIn(['session', 'version'], ''),
    changelogVersion: state.getIn(['allaround', 'changelogVersion']),
  }), (dispatch => ({
    saveChangelogVersion(version) {
      saveChangelogVersion(dispatch, version);
    },
  }))
)(Changelog);
